// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".enable-plugin-support[data-v-0c28a860]{font-size:14px;margin-top:20px}.plugin-setup-error[data-v-0c28a860]{font-size:14px;color:var(--error);margin:10px 0 0 0}.checkbox-info[data-v-0c28a860]{margin-left:20px;opacity:.7}", ""]);
// Exports
module.exports = exports;
